/**
 * Muse For Hair — B2B First Order Minimum Banner
 *
 * Shows a banner on the cart page / cart drawer when a B2B Company customer
 * has fewer than 3 kits in their cart on their first order, and disables
 * the Checkout button until the minimum is met.
 *
 * RETAIL SAFETY: This script must NEVER affect a retail customer.
 *   - Exits immediately if no customer is logged in
 *   - Calls /api/b2b/cart-check which returns is_b2b=false for any retail
 *     customer or any uncertain Shopify Admin lookup
 *   - Only modifies DOM after a positive is_b2b=true response
 */
(function () {
  if (!window.MuseCustomer || !window.MuseCustomer.id) return;

  var KIT_KEYWORD = 'muse diy tape-in extensions';
  var ENDPOINT = 'https://muse-chatbot-production.up.railway.app/api/b2b/cart-check';
  var BANNER_CLASS = 'muse-b2b-banner-wrap';
  var lastSig = null;
  var inflight = false;

  function countKits(items) {
    var total = 0;
    for (var i = 0; i < (items || []).length; i++) {
      var it = items[i];
      var title = ((it.product_title || it.title || '') + '').toLowerCase();
      if (title.indexOf(KIT_KEYWORD) !== -1) {
        total += parseInt(it.quantity || 0, 10) || 0;
      }
    }
    return total;
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  function bannerHtml(data) {
    return (
      '<div id="muse-b2b-min-banner" style="margin:0 0 16px;padding:16px 20px;background:#FBF1EE;border:1px solid #8B2E4F;border-radius:8px;font-family:Arial,sans-serif;color:#1E1714;">' +
        '<p style="margin:0 0 6px;font-size:13px;font-weight:700;color:#8B2E4F;letter-spacing:1px;text-transform:uppercase;">Wholesale first order minimum</p>' +
        '<p style="margin:0;font-size:14px;line-height:1.5;">Your first wholesale order requires <strong>' + data.kits_required + ' kits</strong>. You currently have <strong>' + data.kits_in_cart + '</strong>. Please add <strong>' + data.kits_needed + ' more</strong> kit' + (data.kits_needed === 1 ? '' : 's') + ' to continue.</p>' +
      '</div>'
    );
  }

  function removeBanner() {
    var nodes = document.querySelectorAll('.' + BANNER_CLASS);
    for (var i = 0; i < nodes.length; i++) nodes[i].parentNode.removeChild(nodes[i]);
  }

  function showBanner(data, buttons) {
    removeBanner();
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var wrap = document.createElement('div');
      wrap.className = BANNER_CLASS;
      wrap.innerHTML = bannerHtml(data);
      // Drawer: button sits in a flex row with View Cart, so put the
      // banner above that row (full width) instead of inside it.
      var anchor = btn;
      var parent = btn.parentNode;
      if (parent && parent.children.length > 1 &&
          window.getComputedStyle(parent).display.indexOf('flex') !== -1 &&
          window.getComputedStyle(parent).flexDirection.indexOf('row') === 0) {
        anchor = parent;
      }
      anchor.parentNode.insertBefore(wrap, anchor);
    }
  }

  function disableButtons(buttons) {
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      btn.setAttribute('disabled', 'disabled');
      btn.dataset.museB2bDisabled = '1';
      btn.style.opacity = '0.4';
      btn.style.cursor = 'not-allowed';
      btn.style.pointerEvents = 'none';
    }
  }

  function enableButtons(buttons) {
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      if (btn.dataset.museB2bDisabled === '1') {
        btn.removeAttribute('disabled');
        btn.style.opacity = '';
        btn.style.cursor = '';
        btn.style.pointerEvents = '';
        delete btn.dataset.museB2bDisabled;
      }
    }
  }

  function check() {
    if (inflight) return;
    var buttons = document.querySelectorAll('#checkout-submit');
    if (!buttons.length) return;

    inflight = true;
    fetchCart().then(function (cart) {
      if (!cart) { inflight = false; return; }
      var kits = countKits(cart.items);
      var sig = cart.item_count + '-' + kits;
      if (sig === lastSig) { inflight = false; return; }
      lastSig = sig;

      var url = ENDPOINT +
        '?customer_id=' + encodeURIComponent(window.MuseCustomer.id) +
        '&kits_in_cart=' + kits;

      fetch(url, { credentials: 'omit' })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          inflight = false;
          if (!data || !data.is_b2b) {
            // Retail customer or uncertain — never block
            removeBanner();
            enableButtons(buttons);
            return;
          }
          if (data.block_checkout) {
            showBanner(data, buttons);
            disableButtons(buttons);
          } else {
            removeBanner();
            enableButtons(buttons);
          }
        })
        .catch(function () { inflight = false; });
    });
  }

  function scheduleCheck() {
    lastSig = null;
    setTimeout(check, 250);
  }

  // Initial run
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(check, 500); });
  } else {
    setTimeout(check, 500);
  }

  // Re-check on cart mutations (intercept fetch)
  var origFetch = window.fetch;
  window.fetch = function () {
    var arg0 = arguments[0];
    var url = '';
    if (typeof arg0 === 'string') url = arg0;
    else if (arg0 && arg0.url) url = arg0.url;
    var p = origFetch.apply(this, arguments);
    if (url && /\/cart\/(add|update|change|clear)/.test(url)) {
      p.then(function () { scheduleCheck(); });
    }
    return p;
  };

  // Safety net poll (handles cart drawer opening, AJAX libs that don't use fetch)
  setInterval(check, 4000);
})();

